export enum ResponseStatus {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
}

export interface WhizResponse {
    messageId?: string;
    status: ResponseStatus;
    error?: string;
}
